<template>
  <div class="user-add content-wrapper">
    <div class="page-header">{{ $t('newUser') }}</div>
    <div style="margin-bottom: 40px; margin-left: 5px;">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/user' }">{{ $t('userList') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('newUser') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form ref="form" label-width="150px" style="width: 500px">
      <el-form-item :label="$t('username')" :required="true" style="margin-bottom: 10px;">
        <el-input v-model="user.username" @input="filterUsername(user.username)"></el-input>
        <div style="font-size: 13px; color: #909194; font-style: italic;">{{ $t('acceptOnlyCharacter') }}</div>
      </el-form-item>
      <el-form-item :label="$t('password')" :required="true">
        <!--<el-radio-group v-model="user.isRandomPassword">-->
          <!--<div style="padding: 12px 0 5px 0">-->
            <!--<el-radio :label="STATUS.ENABLE">{{ $t('randomPassword') }}</el-radio>-->
          <!--</div>-->
          <!--<div style="padding: 10px 0 15px 0">-->
            <!--<el-radio :label="STATUS.DISABLE">{{ $t('manualPassword') }}</el-radio>-->
          <!--</div>-->
        <!--</el-radio-group>-->
        <el-input v-model="user.password" :disabled="Boolean(user.isRandomPassword)" type="password" show-password></el-input>
      </el-form-item>
      <el-form-item :label="$t('firstName')">
        <el-input v-model="user.firstName"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lastName')">
        <el-input v-model="user.lastName"></el-input>
      </el-form-item>
      <el-form-item :label="$t('email')" :required="user.isRandomPassword === STATUS.ENABLE">
        <el-input v-model="user.email"></el-input>
      </el-form-item>
      <el-form-item :label="$t('status')">
        <el-radio-group v-model="user.isEnable" fill="#ff0000" >
          <el-radio :label="STATUS.ENABLE">{{ $t('STATUS.ENABLE') }}</el-radio>
          <el-radio :label="STATUS.DISABLE">{{ $t('STATUS.DISABLE') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="onCreateUserButtonClick">{{ $t('create') }}</el-button>
        <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/User/Add.i18n'
import UserApi from '@/api/user-api'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'

export default {
  name: 'UserAdd',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: {},
  i18n: { messages: i18nMessages },
  data () {
    return {
      STATUS,
      user: {
        username: '',
        password: '',
        firstName: '',
        lastName: '',
        email: '',
        isEnable: STATUS.ENABLE,
        isRandomPassword: STATUS.DISABLE
      }
    }
  },
  methods: {
    filterUsername: function (username) {
      this.user.username = username.replace(/[^A-Za-z0-9_\-.]*/g, '')
    },
    onCreateUserButtonClick: async function () {
      try {
        this.startLoading()

        await UserApi.create(this.user)
        this.$router.push({
          name: 'UserList'
        })

        const title = this.$t('createUserSuccessTitle')
        const message = this.$t('createUserSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'UserList'
      })
    }
  }
}
</script>

<style>
.el-form > div {
   text-align: left;
}
</style>
